"use client"

import { Volume2 } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `Volume2Icon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const Volume2Icon = component(Icon)({ as: Volume2 })
